import { useStore } from 'vuex-simple';

export const StoreMixin = {
  data() {
    return {
      store: useStore(this.$store)
    };
  }
};
